<div class="grid gap-4 grid-cols-1">
    <!-- Skeleton for workflow type autocomplete -->
    <div>
        <div class="h-5 bg-light-bgHoverColor dark:bg-dark-bgHoverColor rounded w-1/3 mb-1 animate-pulse"></div>
        <div class="mt-1 h-[42px] bg-light-bgHoverColor dark:bg-dark-bgHoverColor rounded w-full animate-pulse"></div>
    </div>

    <!-- Skeleton for workflow name autocomplete -->
    <div>
        <div class="h-5 bg-light-bgHoverColor dark:bg-dark-bgHoverColor rounded w-1/3 mb-1 animate-pulse"></div>
        <div class="mt-1 h-[42px] bg-light-bgHoverColor dark:bg-dark-bgHoverColor rounded w-full animate-pulse"></div>
    </div>
</div>
